import React, { Component, useEffect, useState } from "react";
import Slider from "react-slick";
import styled, { withTheme } from 'styled-components';
import SlickSliderGames, { GameName } from '../slick-slider/slick-sliderGameLoading';
import { ifProp, theme, withProp } from 'styled-tools';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
//images
// import SlickImagejackpot from '../../images/Jackpot.png';
// import SlickImageRoulette from '../../images/Casino-Tag.jpg';
// import Baccarat from '../../images/Casino_2.jpg';

import LeftArrow from '../../images/Left_arrow1.png';
import RightArrowIcon from "../../images/Right_arrow1.png";
import NormalButton from '../../images/newnormalbutton.png';
import RightArrowHover from '../../images/hover_right arrow.png';
import LeftArrowHover from '../../images/hover_left arrow.png';
// import casino1 from '../../images/sidebetcityCasino.jpg';
// import casino2 from '../../images/zoomrouletteCasino.jpg';
// import casino3 from '../../images/casinoDice.jpg';
// import casino4 from 'src/images/casinoRoulette1.jpg';
// import casino5 from '../../images/casinoBaccarat.jpg';
// import casino6 from '../../images/RouletteCasino.jpg';
// import casino7 from '../../images/blackJackCasino.jpg';
// import casino8 from '../../images/andarbaharEzugi.jpg';
// import casino9 from '../../images/teenpatti2020new.jpg';
// import casino10 from '../../images/teenpatticasino_new.jpg';
// import casino11 from '../../images/teenpatti20_20.jpg';
// import casino12 from '../../images/AviatorMiniBannerEng.jpg';
// import casino13 from '../../images/AndarBaharMiniBanner.jpg';
// import casino14 from '../../images/AviatriXMiniBanner.jpg';
// import casino15 from '../../images/JetXMiniBanner.jpg';
// import casino16 from '../../images/StockMarketMiniBanner.jpg';
// import casino17 from '../../images/MinesMiniBanner.jpg';
// import casino18 from '../../images/PlinkoMiniBanner.jpg';
// import casino19 from '../../images/CrazyTimeMiniBanner.jpg';
// import casino20 from '../../images/LightningDiceMiniBanner.jpg';
// import casino21 from '../../images/RedDoorRouletteMiniBanner.jpg';
// import casino22 from '../../images/LightningRouletteMiniBanner.jpg';
// import casino23 from '../../images/DragonTigerMiniBanner.jpg';

import Activebuttonnew from '../../images/gamebutton.png';

import "slick-carousel/slick/slick-theme.css";
import Modal from "../Modal";
// import GameSearch from "../eu-content/casino-page/game-search";
import config from "src/config/config";
// import Intl from "../common/Intl";

// import casino5Hindi from '../../images/casinoBaccaratHindi.jpg';
// import casino2Hindi from '../../images/zoomrouletteCasinoHindi.jpg';
// import casino6Hindi from '../../images/RouletteCasinoHindi.jpg';
// import casino7Hindi from '../../images/blackJackCasinoHindi.jpg';
// import casino8Hindi from '../../images/andarbaharEzugiHindi.jpg';
// import casino10Hindi from '../../images/teenpatticasino_newHindi.jpg';
// import casino11Hindi from '../../images/teenpatti20_20Hindi.jpg';
// import casino12Hindi from '../../images/AviatorMiniBannerHin.jpg';
// import casino13Hindi from '../../images/AndarBaharMiniBannerHindi.jpg';
// import casino14Hindi from '../../images/AviatriXMiniBannerHinndi.jpg';
// import casino15Hindi from '../../images/JetXMiniBannerHindi.jpg';
// import casino16Hindi from '../../images/StockMarketMiniBannerHindi.jpg';
// import casino17Hindi from '../../images/MinesMiniBannerHindi.jpg';
// import casino18Hindi from '../../images/PlinkoMiniBannerHindi.jpg';
// import casino19Hindi from '../../images/CrazyTimeMiniBannerHindi.jpg';
// import casino20Hindi from '../../images/LightningDiceMiniBannerHindi.jpg';
// import casino21Hindi from '../../images/RedDoorRouletteMiniBannerHindi.jpg';
// import casino22Hindi from '../../images/LightningRouletteMiniBannerHindi.jpg';
// import casino23Hindi from '../../images/DragonTigerMiniBannerHindi.jpg';
import cookieUtil from "src/util/cookieUtil";
import { ECookieName } from "src/util/utilModel";
// import { DemoButton, PlayButton } from "../LiveDealerCraousel";
import {SRTM} from 'src/util/sportradarEvent';
import { withAppContext } from "src/store/initAppContext";
import { CRMDesktopMiniBannerClick } from "src/util/crmUtil";
import { Link } from "react-router-dom";

const Language = cookieUtil.get(ECookieName.COOKIE_LANG);

function SlickSlider(props) {
  const { app: { brandId }, theme } = props
  useEffect(()=>{
    SRTM.init(brandId)
  },[])

  const settings = {
    loop: true,
    arrows: true,
    autoplay: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const [modal, setModal] = useState(false);
  const handleClose = () => setModal(false);

  const toggleModal = (gameName) => {
    setSelectedGame([gameName])
    setModal(!modal);

    //for sport Radar
    if(gameName && typeof gameName === 'object'){
      SRTM.retargetCasinoEvent(brandId, {
        id: gameName.id || '',
        name: gameName.game,
        category: gameName.type,
        image: gameName.imgsrc
      });

      //CRM CRMDesktopMiniBannerClick
      CRMDesktopMiniBannerClick(brandId,gameName.imgsrc)
    }
  }

  const [selectedGame, setSelectedGame] = useState([]);

  // const imagesForFomo = [
  //   {
  //     img: 'slider_six', id: 6, url: (Language === 'hindi-ind') ? casino12Hindi : casino12, game_name: 'Aviator', 
  //     games: {
  //       id: 6,
  //       type: 'SPRIBE',
  //       game: "Aviator",
  //       catagoryName: "Crash Games",
  //       // url: 'http://google.com',
  //       imgsrc: casino12,
  //       platformCode: "WACS",
  //       code: "SPRIBE-aviator",
  //     }
  //   },
  //   {
  //     img: 'slider_twelve', id: 12, url: (Language === 'hindi-ind') ? casino17Hindi : casino17, game_name: 'Mines', games: {
  //       id: 12,
  //       type: 'SPRIBE',
  //       game: "Mines",
  //       catagoryName: "Roulette",
  //       // url: 'http://google.com',
  //       imgsrc: casino17,
  //       platformCode: "WACS",
  //       code: "SPRIBE-mines",
  //     }
  //   },
  //   {
  //     img: 'slider_eleven', id: 11, url: (Language === 'hindi-ind') ? casino16Hindi : casino16, game_name: 'StockMarket', games: {
  //       id: 11,
  //       type: 'EVOLUTION',
  //       game: "StockMarket",
  //       catagoryName: "Stockmarket",
  //       // url: 'http://google.com',
  //       imgsrc: casino16,
  //       platformCode: "WACS",
  //       code: "EVOLUTION-stockmarket-StockMarket00001",
  //     }
  //   },
  //   {
  //     img: 'slider_fifteen', id: 15, url: (Language === 'hindi-ind') ? casino21Hindi : casino21, game_name: 'Red-Door-Roulette', games: {
  //       id: 15,
  //       type: 'EVOLUTION',
  //       game: "Red-Door-Roulette",
  //       catagoryName: "Roulette",
  //       // url: 'http://google.com',
  //       imgsrc: casino21,
  //       platformCode: "WACS",
  //       code: "RedDoorRoulette1",
  //     }
  //   },
  //   {
  //     img: 'slider_nine', id: 9, url: (Language === 'hindi-ind') ? casino14Hindi : casino14, game_name: 'AVIATRIX', games: {
  //       id: 9,
  //       type: 'AVIATRIX',
  //       game: "AVIATRIX",
  //       catagoryName: "Crash Games",
  //       // url: 'http://google.com',
  //       imgsrc: casino14,
  //       platformCode: "AVIATRIX",
  //       code: "nft-aviatrix",
  //     }
  //   },
  //   {
  //     img: 'slider_thirteen', id: 13, url: (Language === 'hindi-ind') ? casino18Hindi : casino18, game_name: 'Plinko', games: {
  //       id: 13,
  //       type: 'SPRIBE',
  //       game: "Plinko",
  //       catagoryName: "Roulette",
  //       // url: 'http://google.com',
  //       imgsrc: casino18,
  //       platformCode: "WACS",
  //       code: "SPRIBE-plinko",
  //     }
  //   },
  //   {
  //     img: 'slider_ten', id: 10, url: (Language === 'hindi-ind') ? casino15Hindi : casino15, game_name: 'JetX', games: {
  //       id: 10,
  //       type: 'SMARTSOFT',
  //       game: "JetX",
  //       catagoryName: "Crash Games",
  //       // url: 'http://google.com',
  //       imgsrc: casino15,
  //       platformCode: "WACS",
  //       code: "SMARTSOFT-JetX_JetX",
  //     }
  //   },
  //   {
  //     img: 'slider_eight', id: 8, url: (Language === 'hindi-ind') ? casino22Hindi : casino22, game_name: 'Lightning Roulette', games: {
  //       id: 8,
  //       type: 'EVOLUTION',
  //       game: "Lightning Roulette",
  //       catagoryName: "Roulette",
  //       // url: 'http://google.com',
  //       imgsrc: casino22,
  //       platformCode: "WACS",
  //       code: "EVOLUTION-roulette-LightningTable01",
  //     }
  //   },
  //   {
  //     img: 'slider_fortnine', id: 14, url: (Language === 'hindi-ind') ? casino19Hindi : casino19, game_name: 'Crazy Time', games: {
  //       id: 14,
  //       type: 'EVOLUTION',
  //       game: "Crazy Time",
  //       catagoryName: "CrazyTime",
  //       // url: 'http://google.com',
  //       imgsrc: casino19,
  //       platformCode: "WACS",
  //       code: "EVOLUTION-crazytime-CrazyTime0000001",
  //     }
  //   },
  //   {
  //     img: 'slider_seven', id: 7, url: (Language === 'hindi-ind') ? casino11Hindi : casino11, game_name: 'TeenPatti 20 20', games: {
  //       id: 7,
  //       type: 'SUPERSPADE',
  //       game: "TeenPatti 20 20",
  //       catagoryName: "TeenPatti",
  //       // url: 'http://google.com',
  //       imgsrc: casino11,
  //       platformCode: "WACS",
  //       code: "Tnptikajgh8t2020",
  //     }
  //   },
  //   {
  //     img: 'slider_sixteen', id: 16, url: (Language === 'hindi-ind') ? casino23Hindi : casino23, game_name: 'Dragon Tiger AG', games: {
  //       id: 16,
  //       type: 'AG',
  //       game: "Dragon Tiger AG",
  //       catagoryName: "Dragon-Tiger",
  //       // url: 'http://google.com',
  //       imgsrc: casino23,
  //       platformCode: "AgTeenpatti",
  //       code: "D060",
  //     }
  //   }    
  // ]


  const miniGameBannersYolo = [
    {
      id: 1,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSpribe : theme.image.miniBannerSpribe,
      game_name: 'SPRIBE',
      href: '/instant-games/spribe'
    },
    {
      id: 2,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerEvolution : theme.image.miniBannerEvolution,
      game_name: 'EVOLUTION',
      href: '/live-casino/evolution'
    },
    {
      id: 3,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerAviatrix : theme.image.miniBannerAviatrix,
      game_name: 'AVIATRIX',
      href: '/instant-games/aviatrix'
    },
    {
      id: 4,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSmartSoft : theme.image.miniBannerSmartSoft,
      game_name: 'SMARTSOFT',
      href: '/instant-games/smartsoft'
    },
    {
      id: 5,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerGalaxsys : theme.image.miniBannerGalaxsys,
      game_name: 'GALAXY',
      href: '/instant-games/galaxsys'
    },
    {
      id: 6,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerTurboGames : theme.image.miniBannerTurboGames,
      game_name: 'GALAXY',
      href: '/instant-games/turbogames'
    },
    {
      id: 7,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerJili : theme.image.miniBannerJili,
      game_name: 'JILI-SLOT',
      href: '/slots/jili-slot'
    },
    {
      id: 8,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSTP : theme.image.miniBannerSTP,
      game_name: 'STP',
      href: '/instant-games/stp'
    },
    {
      id: 9,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSaba : theme.image.miniBannerSaba,
      game_name: 'SABA-SPORT',
      href: '/saba-sports'
    },
    {
      id: 10,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerAgTeenpatti : theme.image.miniBannerAgTeenpatti,
      game_name: 'AG',
      href: '/live-casino/ag'
    },
    {
      id: 11,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerEzugi : theme.image.miniBannerEzugi,
      game_name: 'EZUGI',
      href: '/live-casino/ezugi'
    },
    {
      id: 12,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerBetGames : theme.image.miniBannerBetGames,
      game_name: 'BETGAMES',
      href: '/live-casino/betgames'
    },
    {
      id: 13,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSuperNowa : theme.image.miniBannerSuperNowa,
      game_name: 'SUPERNOWA',
      href: '/live-casino/supernowa'
    },
    {
      id: 14,
      url: (Language === 'hindi-ind') ? theme.image.miniBanner7Netent : theme.image.miniBanner7Netent,
      game_name: 'NETENT',
      href: '/slots/netent'
    },
    {
      id: 15,
      url: (Language === 'hindi-ind') ? theme.image.miniBanner7Mojos : theme.image.miniBanner7Mojos,
      game_name: '7MOJOS',
      href: '/live-casino/7mojos'
    },
    {
      id: 16,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerRedTiger : theme.image.miniBannerRedTiger,
      game_name: 'RED-TIGER',
      href: '/slots/red-tiger'
    },
    {
      id: 17,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSuperSpade : theme.image.miniBannerSuperSpade,
      game_name: 'SUPER-SPADE',
      href: '/live-casino/super-spade'
    },
    {
      id: 18,
      url: (Language === 'hindi-ind') ? theme.image.miniBanner7Evoplay : theme.image.miniBanner7Evoplay,
      game_name: 'EVOPLAY',
      href: '/slots/evoplay'
    },
    {
      id: 19,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerNlc : theme.image.miniBannerNlc,
      game_name: 'NO-LIMIT-CITY',
      href: '/slots/no-limit-city'
    },
  ]

  const miniGameBannersFun = [
    {
      id: 1,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerEvolution : theme.image.miniBannerEvolution,
      game_name: 'EVOLUTION',
      href: '/live-casino/evolution'
    },
    {
      id: 2,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSpribe : theme.image.miniBannerSpribe,
      game_name: 'SPRIBE',
      href: '/instant-games/spribe'
    },
    {
      id: 3,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerJili : theme.image.miniBannerJili,
      game_name: 'JILI-SLOT',
      href: '/slots/jili-slot'
    },
    {
      id: 4,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerAviatrix : theme.image.miniBannerAviatrix,
      game_name: 'AVIATRIX',
      href: '/instant-games/aviatrix'
    },
    {
      id: 5,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSmartSoft : theme.image.miniBannerSmartSoft,
      game_name: 'SMARTSOFT',
      href: '/instant-games/smartsoft'
    },
    {
      id: 6,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerGalaxsys : theme.image.miniBannerGalaxsys,
      game_name: 'GALAXY',
      href: '/instant-games/galaxsys'
    },
    {
      id: 7,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSaba : theme.image.miniBannerSaba,
      game_name: 'SABA-SPORT',
      href: '/saba-sports'
    },
    {
      id: 8,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerTurboGames : theme.image.miniBannerTurboGames,
      game_name: 'GALAXY',
      href: '/instant-games/turbogames'
    },
    {
      id: 9,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerEzugi : theme.image.miniBannerEzugi,
      game_name: 'EZUGI',
      href: '/live-casino/ezugi'
    },
    {
      id: 10,
      url: (Language === 'hindi-ind') ? theme.image.miniBanner7Netent : theme.image.miniBanner7Netent,
      game_name: 'NETENT',
      href: '/slots/netent'
    },
    {
      id: 11,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerSTP : theme.image.miniBannerSTP,
      game_name: 'STP',
      href: '/instant-games/stp'
    },
    {
      id: 12,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerAgTeenpatti : theme.image.miniBannerAgTeenpatti,
      game_name: 'AG',
      href: '/live-casino/ag'
    },
    {
      id: 13,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerRedTiger : theme.image.miniBannerRedTiger,
      game_name: 'RED-TIGER',
      href: '/slots/red-tiger'
    },
    {
      id: 14,
      url: (Language === 'hindi-ind') ? theme.image.miniBanner7Mojos : theme.image.miniBanner7Mojos,
      game_name: '7MOJOS',
      href: '/live-casino/7mojos'
    },
    {
      id: 15,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerBetGames : theme.image.miniBannerBetGames,
      game_name: 'BETGAMES',
      href: '/live-casino/betgames'
    },
    {
      id: 16,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerKaGaming : theme.image.miniBannerKaGaming,
      game_name: 'BETGAMES',
      href: '/slots/ka-gaming'
    },
    {
      id: 17,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerNlc : theme.image.miniBannerNlc,
      game_name: 'NO-LIMIT-CITY',
      href: '/slots/no-limit-city'
    },
    {
      id: 18,
      url: (Language === 'hindi-ind') ? theme.image.miniBannerVivo : theme.image.miniBannerVivo,
      game_name: 'VIVO',
      href: '/live-casino/vivo'
    },
    {
      id: 19,
      url: (Language === 'hindi-ind') ? theme.image.miniBanner7Evoplay : theme.image.miniBanner7Evoplay,
      game_name: 'EVOPLAY',
      href: '/slots/evoplay'
    },
  ]

  const imagePathGroup: any = {
    web: (brandId == 33 || brandId == 34 || brandId == 46 || brandId == 47) ? [...miniGameBannersFun] : [...miniGameBannersYolo]
  };

  return (
    <SliderWrapper>
      <Slider {...settings}>
        {
            imagePathGroup['web'].map((each, index) => {
              return (
                <div key={index}>
                  <Link to = {each.href} key={each.id}>
                    <div className="wrapper">
                      <LazyLoadImage src={`${config.imageS3Host}${each.url}`} effect="none" height="100%" width="100%" placeholder={<PlaceholderImage />} />
                    </div>
                  </Link>
                  {/* <HoverEffect>
                    <ButtonSlider onClick={() => toggleModal(each.games)}>
                      {
                        cookieUtil.get(ECookieName.COOKIE_TOKEN) ? <PlayButton>
                          <button onClick={() => toggleModal(each.games)}><Intl langKey="TITLE@PLAY" /></button>
                        </PlayButton> : <DemoButton>
                          <button onClick={() => toggleModal(each.games)}><Intl langKey="TITLE@DEMO" /></button>
                        </DemoButton>
                      }
                    </ButtonSlider>
                  </HoverEffect> */}
                </div>
              )
            })
        }
      </Slider>
      <Modal show={modal} handleClose={handleClose}>
        <SlickSliderGames modalState={modal} data={selectedGame} open={'true'} />
      </Modal>
    </SliderWrapper>
  )
}

export default withTheme(withAppContext(SlickSlider));

const HoverEffect = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0;
  z-index: 9;
  display: none;
`;

const SliderWrapper = styled.div`
  /* height: 91px; */
  background-color: ${theme('palette.homeCarouselSliderBg')};
  /* padding-top: 5px; */

  .wrapper {
    display: flex;
    width: 100%;
    overflow: hidden;

    h4{
      color: white;
      text-transform: uppercase;
      // font-size: larger;
      margin-bottom:0px;
      position: absolute;
      left: 50px;
      bottom: 28px;
  }

  img{
      width: 100%;
      /* height: 90px; */
      // width:100%;
      display: block;
      margin: auto;
      // padding-left:20px;
      // transform: skew(-20deg);
      transition: transform .5s; /* Animation */

      :hover {
      transform: scale(1.5);
    }
      
    }
  }

    .slick-slide {
      position:relative;
      margin: 0px 2px;

      :hover {
        ${HoverEffect} {
          display:  block;
          background: rgba(5, 11, 9, 0.5);
          // transform: skew(-27deg);
          transition: 0.3s ease-in;
        }
      }
    }

  .slick-arrow{
      color: black;
              }

  .slick-prev{
    z-index: 100;
    left: 0px;
    color: black;
    position: absolute;
    bottom: 50px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    height: 100%;
    width: 157px;
    border: none;
    background: ${theme('palette.homeCarouselSliderPrevBg')};
    backdrop-filter: blur(12.649999618530273px);
    font-size: 0px;
    clip-path: polygon(0 0, 100% 0%, 97% 100%, 0% 100%);
    clip-path: polygon(0 0, 70% 0%, 100% 100%, 0% 100%);

    :hover.slick-prev:before {
      content: "";
      width: 36px;
      height: 36px;
      display: inline-block;
      background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.homeCarouselSliderLeftArrowHover')});
      background-size: 30px 30px;
      background-position:center center;
      background-repeat: no-repeat;
      margin-right: 30px;
    }
  }
  .slick-prev:before {
    content: "";
    width: 36px;
    height: 36px;
    display: inline-block;
    background-image: url(${LeftArrow});
    background-size: 30px 30px;
    background-position:center center;
    background-repeat: no-repeat;
    margin-right: 30px;
  }

  .slick-next{
    z-index: 100;
    right: 0px;
    color: black;
    position: absolute;
    bottom: 50px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    height: 100%;
    width: 157px;
    border: none;
    background: ${theme('palette.homeCarouselSliderNextBg')};
    backdrop-filter: blur(12.649999618530273px);
    font-size:0px;
    clip-path: polygon(30% 0, 0% 100%, 100% 100%, 100% 0%);

    :hover.slick-next:before {
      content: "";
      width: 36px;
      height: 36px;
      display: inline-block;
      background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.homeCarouselSliderRightArrowHover')});
      background-size: 30px 30px;
      background-position:center center;
      background-repeat: no-repeat;
      margin-left: 30px;
    }
  }

  .slick-next:before {
    content: "";
    width: 36px;
    height: 36px;
    display: inline-block;
    background-image: url(${RightArrowIcon});
    background-size: 30px 30px;
    background-position:center center;
    background-repeat: no-repeat;
    margin-left: 30px;
  }

  .slick-list{
    display:flex;


    
  .slick-slider slick-initialized{
    /* height:91px; */

  }

  .slick-slide slick-active slick-current{
    /* height:90px; */
  }


    .slick-track{
      opacity: 1;
      transform: translate3d(0px, 0px, 0px);
      display: flex;
      width: 1746px;
      justify-content: center;
      /* height:90px; */




      .slick-slide slick-active slick-current{
        width:auto;
      }
    }
  }


  .slick-slider {
      z-index: 1;
      /* height: 91px; */
      padding-top:1px;
      
  }

  .slick-dots{
      display:none;
  }

  .slick-arrow slick-prev slick-disabled{
      color:black;
      display: none;
  }

  .slick-arrow slick-next{
      color: green;
  }
`;


const ButtonSlider = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
  font-size: 12px;
  // background-image: url(${NormalButton});
  // background-image: url(${Activebuttonnew});
  // background-image: url(${config.imageS3Host}/static/snk/${theme('image.gameFace')});
  background-repeat: no-repeat;
  background-position: center;
  // transform: skew(25deg);
  cursor: pointer;
  text-align: center;
  padding: 8px;

   :hover{
     /* background-image: url(${Activebuttonnew}); */
     transition: 0.3s ease-in;
     background-repeat: no-repeat;
     transform: skew(-5deg);
   }

  p{
    margin:0px;
    transform: skew(3deg);
  

  }

  
`;